import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/starter-edition/page-client.tsx");
